import { RULE_TYPES } from "../config/rules.config";
import { getTargetKey } from "./ruleTargetHelpers";

const SPECIAL_RULE_KEYS = new Set([
  RULE_TYPES.LOCK_WHEN_CHECKED,
  RULE_TYPES.DISABLE_WHEN_CHECKED,
  RULE_TYPES.SPECIAL_CONDITION,
]);

export const computeLockedPermissions = (formValues, rules) => {
  const locked = new Set();
  const rule = rules[RULE_TYPES.LOCK_WHEN_CHECKED];
  if (!rule?.enabled || !rule?.targets || !formValues) return locked;

  Object.entries(rule.targets).forEach(([triggerKey, lockedList]) => {
    if (formValues[triggerKey] === true) {
      lockedList.forEach((entry) => locked.add(getTargetKey(entry)));
    }
  });

  return locked;
};

export const isSpecialConditionSatisfied = (permKey, formValues, rules) => {
  const rule = rules[RULE_TYPES.SPECIAL_CONDITION];
  if (!rule?.enabled) return true;

  const condition = rule?.targets?.[permKey];
  if (!condition) return true;

  if (condition.requiresAny) {
    return condition.requiresAny.some((key) => formValues?.[key] === true);
  }

  return true;
};

export const computeDisabledPermissions = (formValues, rules) => {
  const disabled = new Set();

  const rule = rules[RULE_TYPES.DISABLE_WHEN_CHECKED];
  if (rule?.enabled && rule?.targets && formValues) {
    Object.entries(rule.targets).forEach(([triggerKey, disabledList]) => {
      if (formValues[triggerKey] === true) {
        disabledList.forEach((key) => disabled.add(key));
      }
    });
  }

  const sc = rules[RULE_TYPES.SPECIAL_CONDITION];
  if (sc?.enabled && sc?.targets && formValues) {
    Object.entries(sc.targets).forEach(([targetKey]) => {
      if (!isSpecialConditionSatisfied(targetKey, formValues, rules)) {
        disabled.add(targetKey);
      }
    });
  }

  return disabled;
};

export const getCascadeRuleForParent = (parentKey, rules) => {
  for (const [ruleType, ruleConfig] of Object.entries(rules)) {
    if (SPECIAL_RULE_KEYS.has(ruleType)) continue;
    if (ruleConfig?.enabled && ruleConfig?.parentKey === parentKey) {
      return ruleConfig.behavior;
    }
  }
  return null;
};

export const getCascadeConfigForParent = (parentKey, rules) => {
  for (const [ruleType, ruleConfig] of Object.entries(rules)) {
    if (SPECIAL_RULE_KEYS.has(ruleType)) continue;
    if (ruleConfig?.enabled && ruleConfig?.parentKey === parentKey) {
      return ruleConfig;
    }
  }
  return null;
};